<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import groupBy from "lodash/groupBy";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import UploadPopover from "@/components/widgets/upload-popover.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import RequisitionModal from "@/components/modals/requisition-modal.vue";

export default {
  page: {
    title: "Requisition"
  },
  components: {
    Layout,
    PageHeader,
    UploadPopover,
    PrintOptions,
    RequisitionModal
  },
  data() {
    return {
      title: "Requisition",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: "Requisition",
          active: true
        }
      ],
      currencyMask: createNumberMask({
        prefix: "",
        allowDecimal: true
      }),
      quantityMask: createNumberMask({
        prefix: "",
        includeThousandsSeparator: false
      }),
      modalTitle: "",
      tableData: [],
      itemData: null,
      filter: "",
      pageOptions: [10, 25, 50, 100],
      perPage: 10,
      currentPage: 1,
      perPageItem: 10,
      currentPageForm: 1,
      loading: false,
      form: [],
      updateForm: {
        id: 0,
        itemName: "",
        description: "",
        iarItemId: 0,
        quantity: 0,
        maxQuantitiy: 0,
        endUserId: "",
        propertyLocationId: "",
        note: ""
      },
      campusId: this.$store.state.data.selectedCampus.id,
      selectedDU: this.$store.state.data.selectedDU.id,
      dashboardData: null,
      employeeName: "",
      employeeType: "",
      location: "",
      locationType: "",
      requisitionIndex: -1,
      itemIndex: -1,
      tabIndex: 0,
      setAllEmployee: false,
      setAllLocation: false,
      isAdmin: this.$store.state.decrypt.isAdmin(),
      token: this.$store.state.decrypt.getToken(),
      uploadOptions: {
        type: "Requisition",
        placement: "lefttop",
        folder: "Requisition"
      },
      selectedRequisitionId: null,
    };
  },
  computed: {
    filtered() {
      let data = this.tableData;
      if (this.filter.trim() != "" && this.filter) {
        if (this.tabIndex == 0) {
          data = data.filter((item) => {
            if (item.itemName) {
              if (
                item.itemName.toUpperCase().includes(this.filter.toUpperCase())
              )
                return item.itemName
                  .toUpperCase()
                  .includes(this.filter.toUpperCase());
            }
            if (item.description) {
              if (
                item.description
                  .toUpperCase()
                  .includes(this.filter.toUpperCase())
              )
                return item.description
                  .toUpperCase()
                  .includes(this.filter.toUpperCase());
            }
            if (item.poNumber) {
              if (
                item.poNumber.toUpperCase().includes(this.filter.toUpperCase())
              )
                return item.poNumber
                  .toUpperCase()
                  .includes(this.filter.toUpperCase());
            }
          });
        } else {
          data = data.filter((item) => {
            if (item.requestedDate) {
              if (
                this.formatDate(new Date(item.requestedDate))
                  .toUpperCase()
                  .includes(this.filter.toUpperCase())
              )
                return this.formatDate(new Date(item.requestedDate))
                  .toUpperCase()
                  .includes(this.filter.toUpperCase());
            }
            if (item.requisitionItems[0].iarItem.iar.po.poNumber) {
              if (
                item.requisitionItems[0].iarItem.iar.po.poNumber
                  .toUpperCase()
                  .includes(this.filter.toUpperCase())
              )
                return item.requisitionItems[0].iarItem.iar.po.poNumber
                  .toUpperCase()
                  .includes(this.filter.toUpperCase());
            }
          });
        }
      }
      return data;
    },
    grouped() {
      var array = [];
      var x = groupBy(this.filtered, "supplierName");
      for (const key in x) {
        var supplier = key;
        var y = groupBy(x[key], "poNumber");
        for (const key in y) {
          array.push({
            poNumber: key,
            supplier: supplier,
            availableItems: y[key],
            toggleAll: false,
            visible: false
          });
        }
      }
      return array;
    },
    paginated() {
      let data = this.tabIndex == 0 ? this.grouped : this.filtered;
      var total = this.currentPage * this.perPage;
      var currentData = data.slice(total - this.perPage, total);
      if (this.currentPage > 1 && currentData.length == 0) {
        total = (this.currentPage - 1) * this.perPage;
        currentData = data.slice(total - this.perPage, total);
      }
      return currentData;
    },
    rows() {
      return this.tabIndex == 0 ? this.grouped.length : this.filtered.length;
    },
    // filteredForm() {
    //   var currentData = [];
    //   if (this.form?.length) {
    //     let data = this.form;
    //     var total = this.currentPageForm;
    //     currentData = data.slice(total - 1, total);
    //     if (this.currentPageForm > 1 && currentData.length == 0) {
    //       total = this.currentPageForm - 1;
    //       currentData = data.slice(total - 1, total);
    //     }
    //   }
    //   return currentData;
    // }
  },
  created() {
    this.changeCampus();
  },
  methods: {
    changeCampus() {
      this.campusId = this.$store.state.data.selectedCampus.id;
      this.selectedDU = this.$store.state.data.selectedDU.id;
      if (this.tabIndex == 0) {
        this.getAvailable();
      } else if (this.tabIndex == 1) {
        this.getDraft();
      } else if (this.tabIndex == 2) {
        this.getPosted();
      } else if (this.tabIndex == 3) {
        this.getCompleted();
      }
      setTimeout(() => {
        this.dashboardData = JSON.parse(localStorage.getItem("dashboardData"));
      }, 500);
    },
    getAvailable() {
      this.loading = true;
      this.$store
        .dispatch("requisition/GetRequisitionAvailableByDu", this.selectedDU)
        .then((res) => {
          res.data.forEach((item) => {
            item.toggleSelected = false;
          });
          this.tableData = res.data.reverse();
          this.loading = false;
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast(
              "Something went wrong - Getting available items!",
              "error"
            );
          }
          this.loading = false;
        });
    },
    getDraft() {
      this.loading = true;
      this.$store
        .dispatch("requisition/GetRequisitionDraftByDu", this.selectedDU)
        .then((res) => {
          res.data.forEach((item) => {
            item.visible = false;
            item.addDocu = false;
            item.attachmentLoading = false;
            item.requisitionFiles = [];
            item.viewFile = false;
          });
          this.tableData = res.data.reverse();
          this.loading = false;
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast(
              "Something went wrong - Getting draft items!",
              "error"
            );
          }
          this.loading = false;
        });
    },
    getPosted() {
      this.loading = true;
      this.$store
        .dispatch("requisition/GetRequisitionPendingByDu", this.selectedDU)
        .then((res) => {
          res.data.forEach((item) => {
            item.visible = false;
            item.addDocu = false;
            item.attachmentLoading = false;
            item.requisitionFiles = [];
            item.viewFile = false;
          });
          this.tableData = res.data.reverse();
          this.loading = false;
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast(
              "Something went wrong - Getting posted items!",
              "error"
            );
          }
          this.loading = false;
        });
    },
    getCompleted() {
      this.loading = true;
      this.$store
        .dispatch("requisition/GetRequisitionCompletedByDu", this.selectedDU)
        .then((res) => {
          res.data.forEach((item) => {
            item.visible = false;
            item.addDocu = false;
            item.attachmentLoading = false;
            item.requisitionFiles = [];
            item.viewFile = false;
          });
          this.tableData = res.data.reverse();
          this.loading = false;
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast(
              "Something went wrong - Getting posted items!",
              "error"
            );
          }
          this.loading = false;
        });
    },
    showDetails(row) {
      row.visible = !row.visible;
      if (row.visible) {
        row.requisitionItems.forEach((item) => {
          item.accountableOfficer = null;
          this.$store
            .dispatch("externalemployee/GetByEmployeeId", item.endUserId)
            .then((res) => {
              item.accountableOfficer = res.data;
            });
        });
      }
    },
    formatAccountableOfficer(data) {
      if(!data) return "";
      let firstName = data.firstName ? data.firstName.charAt(0).toUpperCase() + data.firstName.slice(1) : "";
      let middleName = data.middleName ? data.middleName.charAt(0).toUpperCase() + "." : "";
      let lastName = data.lastName ? data.lastName.charAt(0).toUpperCase() + data.lastName.slice(1) : "";
      return `${firstName} ${middleName} ${lastName}`;
    },
    onCreate(modalData) {
      if(modalData.isUpdate) {
        let modalForm = modalData.form[0];
        this.$store
          .dispatch("requisition/UpdateRequisitionItem", modalForm)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            let reqIndex = this.tableData.findIndex(x => x.id == this.selectedRequisitionId);
            let itemIndex = this.tableData[reqIndex].requisitionItems.findIndex(x => x.id == modalForm.id);
            let updateItem = this.tableData[reqIndex].requisitionItems[itemIndex];
            updateItem.note = modalForm.note;
            updateItem.endUserId = modalForm.endUserId;
            updateItem.accountableOfficer = {
              ...updateItem.accountableOfficer,
              firstName: modalForm.firstName,
              middleName: modalForm.middleName,
              lastName: modalForm.lastName
            }
            updateItem.propertyLocationId = modalForm.propertyLocationId;
            updateItem.propertyLocation.location = modalForm.location;
            this.showToast("Successfully updated!", "success");
            this.$bvModal.hide("req-modal");
          })
          .catch((err) => {
            this.showToast("Something went wrong - Updating Requisition!", "error");
          });
      }else{
        var props = {
          requisitionItems: modalData.form,
          campusId: this.$store.state.data.selectedCampus.id,
          deliveryUnitId: this.$store.state.data.selectedDU.id,
          requisitionNumber: "",
          status: "DRAFT"
        };
        this.$store
          .dispatch("requisition/CreateRequisition", props)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            this.getAvailable();
            this.dashboardData.needRequisitionAssign = this.dashboardData.needRequisitionAssign - modalData.form.length;
            this.dashboardData.draftRequisitions = this.dashboardData.draftRequisitions + 1;
            localStorage.setItem("dashboardData", JSON.stringify(this.dashboardData));
            this.showToast("Successfully created!", "success");
            this.$bvModal.hide("req-modal");
          })
          .catch((err) => {
            this.showToast("Something went wrong - Creating Requisition!", "error");
          });
      }
    },
    createRequisition(items) {
      this.$refs.reqModal.resetForm(items.availableItems.filter(x => x.toggleSelected));
      this.modalTitle = "Create Requisition";
      this.$bvModal.show("req-modal");
    },
    updateRequisition(props, requisitionId) {
      this.selectedRequisitionId = requisitionId;
      this.$refs.reqModal.updateForm(props);
      this.modalTitle = "Update Requisition";
      this.$bvModal.show("req-modal");
    },
    onPost(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You are about to post this requisition!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, post it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("requisition/PostRequisition", id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.dashboardData.draftRequisitions =
                this.dashboardData.draftRequisitions - 1;
              localStorage.setItem(
                "dashboardData",
                JSON.stringify(this.dashboardData)
              );
              var itemIndex = this.tableData.findIndex((item) => item.id == id);
              this.tableData.splice(itemIndex, 1);
              this.showToast("Successfully posted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be posted!", "error");
            });
        }
      });
    },
    onDelete(props) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("requisition/DeleteRequisition", props.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.dashboardData.needRequisitionAssign =
                this.dashboardData.needRequisitionAssign +
                props.requisitionItems.length;
              this.dashboardData.draftRequisitions =
                this.dashboardData.draftRequisitions - 1;
              localStorage.setItem(
                "dashboardData",
                JSON.stringify(this.dashboardData)
              );
              var itemIndex = this.tableData.findIndex(
                (item) => item.id == props.id
              );
              this.tableData.splice(itemIndex, 1);
              this.showToast("Successfully deleted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    setToggle(items) {
      items.availableItems.forEach((item) => {
        item.toggleSelected = false;
      });
      if (items.toggleAll === true) {
        items.availableItems.forEach((item) => {
          item.toggleSelected = true;
        });
      }
    },
    checkItems(items) {
      var count = 0;
      items.availableItems.forEach((item) => {
        if (item.toggleSelected == true) {
          count++;
        }
      });
      if (count > 0) return true;
      else return false;
    },
    checkToggle(items) {
      var count = 0;
      items.availableItems.forEach((item) => {
        item.toggleSelected && count++;
      });
      if (count === items.availableItems.length) {
        items.toggleAll = true;
      } else {
        items.toggleAll = false;
      }
      this.$forceUpdate();
    },
    openDocument(x) {
      this.readFile(x.id);
    },
    uploadedFiles() {},
    async getAttachments(row) {
      row.viewFile = true;
      row.requisitionFiles = [];
      row.attachmentLoading = true;
      await this.$store
        .dispatch("filemanager/GetFiles", {
          id: row.id,
          type: "Requisition"
        })
        .then((res) => {
          res.data.forEach((item) => {
            row.requisitionFiles.push(item);
          });
        })
        .catch(() => {
          this.showToast("Something went wrong - Getting documents!", "error");
        });
      await this.$store
        .dispatch("filemanager/GetFiles", {
          id: row.requisitionItems[0].iarItem.iar.poId,
          type: "Purchase Order"
        })
        .then((res) => {
          res.data.forEach((item) => {
            row.requisitionFiles.push(item);
          });
        })
        .catch(() => {
          this.showToast("Something went wrong - Getting documents!", "error");
        });
      row.attachmentLoading = false;
    },
    removeFile(id, parentId) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, remove it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("filemanager/DeleteFile", id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let index = this.tableData.findIndex(
                (item) => item.id == parentId
              );
              let yIndex = this.tableData[index].requisitionFiles.findIndex(
                (item) => item.id == id
              );
              this.tableData[index].requisitionFiles.splice(yIndex, 1);
              this.showToast("Successfully removed!", "success");
            })
            .catch(() => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    async printRIS(id) {
      var apiUrl = `api/Report/Inspection/Requisition/RIS`;
      var routeVariables = [id];
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables
      });
      this.$bvModal.show("print-options-modal");
    }
  }
};
</script>
<template>
  <Layout @changeCampus="changeCampus">
    <PageHeader :title="title" :items="items" />
    <!-- Create from Available -->
    <RequisitionModal 
      :modalTitle="modalTitle"
      transactionType="requisition"
      ref="reqModal"
      from="office"
      @submit="onCreate"
    />
    <!-- Update Requisition Item -->
    <b-modal
      id="modal-update"
      :title="modalTitle"
      size="lg"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
    >
      <form @submit.prevent="onUpdate" class="needs-validation" ref="fcForm">
        <div class="d-flex">
          <div class="py-2" style="min-width: 8%">
            <div class="text-white">{{ updateForm.itemName }}</div>
            <small>{{ updateForm.description }}</small>
          </div>
          <div class="py-2 px-2" style="min-width: 20%">
            <div class="d-flex align-items-center">
              <small class="mx-2">Qty:</small>
              <div class="form-control">{{ updateForm.quantity }}</div>
            </div>
          </div>
        </div>
        <hr class="my-2" />
        <div class="mb-3">
          <label for="quantity">End User</label>
          <b-input-group>
            <template #append>
              <b-button @click="getEmployee('update')" variant="outline-info"
                ><i class="mdi mdi-clipboard-text-search-outline"></i
              ></b-button>
            </template>
            <input
              autocomplete="off"
              type="text"
              disabled
              placeholder="Search Employee..."
              class="form-control"
              :class="{
                'is-invalid':
                  submitted &&
                  (updateForm.endUserId == '' || updateForm.endUserId == null)
              }"
              v-model="employeeName"
            />
          </b-input-group>
          <div
            v-if="
              submitted &&
                (updateForm.endUserId == '' || updateForm.endUserId == null)
            "
            class="invalid-feedback"
          >
            <span>This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="quantity">Location</label>
          <b-input-group>
            <template #append>
              <b-button @click="getLocation('update')" variant="outline-info"
                ><i class="mdi mdi-clipboard-text-search-outline"></i
              ></b-button>
            </template>
            <input
              autocomplete="off"
              type="text"
              disabled
              placeholder="Search Location..."
              class="form-control"
              :class="{
                'is-invalid':
                  submitted &&
                  (updateForm.propertyLocationId == '' ||
                    updateForm.propertyLocationId == null)
              }"
              v-model="location"
            />
          </b-input-group>
          <div
            v-if="
              submitted &&
                (updateForm.propertyLocationId == '' ||
                  updateForm.propertyLocationId == null)
            "
            class="invalid-feedback"
          >
            <span>This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="note">Note</label>
          <textarea
            id="note"
            rows="4"
            v-model="updateForm.note"
            placeholder="Enter Notes..."
            class="form-control"
            autocomplete="off"
          ></textarea>
        </div>
        <hr class="my-2" />
        <div class="d-flex flex-row-reverse mt-3">
          <button type="submit" class="btn btn-primary">Update</button>
        </div>
      </form>
    </b-modal>
    <!-- Main -->
    <b-tabs
      content-class="text-muted"
      v-model="tabIndex"
      nav-class="nav-tabs-custom"
    >
      <!-- Available -->
      <b-tab
        @click="
          getAvailable();
          perPage = 10;
          currentPage = 1;
        "
      >
        <template v-slot:title>
          <div class="d-flex align-items-center">
            <span class="d-inline-block d-sm-none">
              <i class="mdi mdi-clipboard-multiple-outline"></i>
            </span>
            <span class="d-none d-sm-inline-block">Available</span>
            <span
              class="badge bg-danger ms-2"
              v-if="dashboardData && dashboardData.needRequisitionAssign > 0"
              >{{ dashboardData.needRequisitionAssign }}</span
            >
          </div>
        </template>
        <div v-if="tabIndex == 0" class="card-body ps-0 pe-0">
          <div class="d-flex align-items-center justify-content-between mb-2">
            <h5 class="mb-0">List of Available Items</h5>
            <div class="d-flex">
              <div id="tickets-table_filter" class="dataTables_filter me-1">
                <label class="d-inline-flex align-items-center">
                  <b-form-input
                    autocomplete="off"
                    v-model="filter"
                    type="search"
                    placeholder="Search Item..."
                    class="form-control"
                  ></b-form-input>
                </label>
              </div>
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center mb-0">
                  <b-form-select
                    class="form-select"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  >
                  </b-form-select>
                </label>
              </div>
            </div>
          </div>
          <b-card v-if="loading">
            <div class="d-flex align-items-center justify-content-center">
              <div class="preloader-component me-2">
                <div class="status">
                  <div class="spinner-chase w-25px h-25px">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>
              </div>
              <h5 class="mb-0">Loading...</h5>
            </div>
          </b-card>
          <b-card class="text-center" v-else-if="paginated.length == 0">
            <div v-if="filter != ''">
              <i class="fas fa-exclamation-triangle me-2"></i>There are no items
              matching your request
            </div>
            <div v-else>
              <i class="fas fa-exclamation-triangle me-2"></i>No items available
            </div>
          </b-card>
          <div v-else class="text-muted">
            <div role="tablist" v-for="(x, index) in paginated" :key="x.id">
              <b-card
                no-body
                class="m-0 mb-3"
                style="min-width: fit-content"
                :style="`z-index: ${paginated.length - index + 10}`"
              >
                <b-card-header
                  class="cursor-pointer"
                  @click="
                    x.visible = !x.visible;
                    $forceUpdate();
                  "
                >
                  <div class="position-absolute" style="top:-5px; left:-10px;">
                    <span class="badge bg-danger ms-2">{{
                      x.availableItems.length
                    }}</span>
                  </div>
                  <!-- <small>{{ x.availableItems.length > 1 ? `${x.availableItems.length} Items Available` : `${x.availableItems.length} Item Available`  }}</small> -->
                  <h6 class="mb-0">PO No {{ x.poNumber }}</h6>
                  <a>
                    <small>
                      <span>
                        Show Details
                      </span>
                      <i
                        class="bx bx-chevron-right rotate"
                        :class="{
                          'rotate-90': x.visible
                        }"
                      ></i>
                    </small>
                  </a>
                </b-card-header>
              </b-card>
              <b-collapse :visible="x.visible" role="tabpanel">
                <div v-if="x.visible" class="ps-5">
                  <div
                    class="d-flex align-items-center justify-content-between mb-3"
                  >
                    <h4 class="m-0 pt-2">Available Items:</h4>
                    <div class="d-flex gap-1">
                      <button
                        v-if="checkItems(x)"
                        type="button"
                        @click="createRequisition(x)"
                        class="btn btn-sm btn-primary d-flex align-items-center ms-1"
                      >
                        <i class="bx bx-plus fs-6 me-1"></i>Create Requisition
                      </button>
                    </div>
                  </div>
                  <b-card
                    no-body
                    class="m-0 mb-3"
                    style="min-width: fit-content"
                  >
                    <b-card-header>
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <h6 class="text-muted m-0" style="min-width: 200px">
                          Item Name
                        </h6>
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <h6
                            class="text-muted text-center m-0"
                            style="min-width: 100px"
                          >
                            Qty
                          </h6>
                          <h6
                            class="text-muted text-center m-0"
                            style="min-width: 180px"
                          >
                            Unit Cost
                          </h6>
                          <h6
                            class="text-muted text-center m-0"
                            style="min-width: 180px"
                          >
                            Total Cost
                          </h6>
                          <div
                            class="d-flex justify-content-center"
                            style="min-width: 35px"
                          >
                            <div
                              class="form-check form-checkbox-outline form-check-success"
                            >
                              <input
                                type="checkbox"
                                :id="`checkbox-toggleAll`"
                                checked="checked"
                                class="form-check-input me-1"
                                @change="setToggle(x)"
                                v-model="x.toggleAll"
                              /><label
                                :for="`checkbox-toggleAll`"
                                class="form-check-label"
                              >
                                All
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-card-header>
                  </b-card>
                  <div
                    role="tablist"
                    v-for="(y, index) in x.availableItems"
                    :key="y.id"
                  >
                    <b-card
                      no-body
                      class="m-0 mb-3"
                      style="min-width: fit-content"
                      :style="
                        `z-index: ${x.availableItems.length - index + 10}`
                      "
                    >
                      <b-card-header>
                        <div class="d-flex justify-content-between">
                          <div style="min-width: 200px">
                            <h5 class="m-0">{{ y.itemName }}</h5>
                            <small>{{ y.description }}</small>
                          </div>
                          <div
                            class="d-flex align-items-center justify-content-between"
                          >
                            <div
                              class="text-info text-center"
                              style="min-width: 100px"
                            >
                              {{ y.availableQuantity }}
                            </div>
                            <div
                              class="text-warning text-center"
                              style="min-width: 180px"
                            >
                              {{ formatCurrency(y.unitCost) }}
                            </div>
                            <div
                              class="text-warning text-center"
                              style="min-width: 180px"
                            >
                              {{
                                formatCurrency(y.availableQuantity * y.unitCost)
                              }}
                            </div>
                            <div
                              class="d-flex justify-content-center"
                              style="min-width: 35px"
                            >
                              <div
                                class="form-check form-checkbox-outline form-check-success"
                              >
                                <input
                                  type="checkbox"
                                  :id="`checkbox-${y.id}`"
                                  class="form-check-input"
                                  @change="checkToggle(x)"
                                  v-model="y.toggleSelected"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </b-card-header>
                    </b-card>
                  </div>
                </div>
              </b-collapse>
            </div>
          </div>
          <div class="row">
            <div v-if="rows > 0" class="col">
              Showing {{ (currentPage - 1) * perPage + 1 }} -
              {{
                rows > (currentPage - 1) * perPage + perPage
                  ? (currentPage - 1) * perPage + perPage
                  : rows
              }}
              of {{ rows }}
            </div>
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul
                  class="pagination pagination-rounded mb-0"
                  style="z-index: -1"
                >
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <!-- Draft -->
      <b-tab
        @click="
          getDraft();
          perPage = 10;
          currentPage = 1;
        "
      >
        <template v-slot:title>
          <div class="d-flex align-items-center">
            <span class="d-inline-block d-sm-none">
              <i class="mdi mdi-clipboard-edit-outline"></i>
            </span>
            <span class="d-none d-sm-inline-block">Draft</span>
            <span
              class="badge bg-danger ms-2"
              v-if="dashboardData && dashboardData.draftRequisitions > 0"
              >{{ dashboardData.draftRequisitions }}</span
            >
          </div>
        </template>
        <div v-if="tabIndex == 1" class="card-body ps-0 pe-0">
          <div class="row mb-2">
            <div class="col-md-6">
              <div class="d-flex align-items-center h-100">
                <h5 class="mb-0">List of Draft Requisition</h5>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex float-end">
                <div id="tickets-table_filter" class="dataTables_filter me-1">
                  <label class="d-inline-flex align-items-center">
                    <b-form-input
                      autocomplete="off"
                      v-model="filter"
                      type="search"
                      placeholder="Search Item..."
                      class="form-control"
                    ></b-form-input>
                  </label>
                </div>
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center mb-0">
                    <b-form-select
                      class="form-select"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    >
                    </b-form-select>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <b-card v-if="loading">
            <div class="d-flex align-items-center justify-content-center">
              <div class="preloader-component me-2">
                <div class="status">
                  <div class="spinner-chase w-25px h-25px">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>
              </div>
              <h5 class="mb-0">Loading...</h5>
            </div>
          </b-card>
          <b-card class="text-center" v-else-if="tableData.length == 0">
            <div v-if="filter != ''">
              <i class="fas fa-exclamation-triangle me-2"></i>There are no items
              matching your request
            </div>
            <div v-else>
              <i class="fas fa-exclamation-triangle me-2"></i>No requisitions
              draft
            </div>
          </b-card>
          <div v-else class="text-muted">
            <b-card no-body class="m-0 mb-3" style="min-width: fit-content">
              <b-card-header>
                <div class="d-flex justify-content-between">
                  <h6 class="text-muted m-0" style="min-width: 200px">
                    Requisition
                  </h6>
                  <h6
                    class="text-muted text-center m-0"
                    style="min-width: 100px"
                  >
                    Action
                  </h6>
                </div>
              </b-card-header>
            </b-card>
            <div role="tablist" v-for="(x, index) in paginated" :key="x.id">
              <b-card
                no-body
                class="m-0 mb-3 py-1"
                style="min-width: fit-content"
                :style="`z-index: ${paginated.length - index + 10}`"
              >
                <b-card-header>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div style="min-width: 200px">
                      <h6
                        class="m-0"
                        v-if="
                          x.requisitionItems && x.requisitionItems.length > 0
                        "
                      >
                        PO# {{ x.requisitionItems[0].iarItem.iar.po.poNumber }}
                      </h6>
                      <small class="d-flex align-items-center">
                        <div>
                          {{
                            x.requestedDate
                              ? formatDate(new Date(x.requestedDate))
                              : null
                          }}
                        </div>
                        <div class="ms-1 me-1">|</div>
                        <div>
                          <a
                            href="javascript: void(0);"
                            class="text-success d-flex align-items-center"
                            @click="showDetails(x)"
                          >
                            {{ x.visible ? "Hide" : "Show" }}
                            Items
                            <i
                              class="bx bx-chevron-right rotate font-size-14"
                              :class="{
                                'rotate-90': x.visible
                              }"
                            ></i>
                          </a>
                        </div>
                      </small>
                    </div>
                    <div class="text-center" style="min-width: 100px">
                      <i
                        title="Print RIS"
                        class="bx bx-printer font-size-18 text-purple cursor-pointer me-2"
                        @click="printRIS(x.id)"
                      ></i>
                      <i
                        title="Delete Item"
                        class="mdi mdi-trash-can-outline font-size-18 text-danger cursor-pointer me-2"
                        @click="onDelete(x)"
                      ></i>
                      <i
                        title="Post Item"
                        class="mdi mdi-check-underline font-size-18 text-success cursor-pointer"
                        @click="onPost(x.id)"
                      ></i>
                    </div>
                  </div>
                </b-card-header>
                <b-collapse
                  :visible="x.visible"
                  :accordion="`draft-accordion-${x.id}`"
                  role="tabpanel"
                >
                  <b-card-body
                    v-if="x.visible"
                    class="border border-3 border-bottom-0 border-start-0 border-end-0"
                  >
                    <div class="d-flex">
                      <div class="me-3" style="min-width: 250px">
                        <div>
                          <b class="font-size-14 me-1">Attachments:</b>
                          <a
                            href="javascript:void(0);"
                            @click="getAttachments(x)"
                            :id="`draft-viewFiles-${x.id}`"
                            >[Show attachments]</a
                          >
                          <b-popover
                            :target="`draft-viewFiles-${x.id}`"
                            triggers="click"
                            placement="right"
                            :show.sync="x.viewFile"
                            custom-class="popover-supplier"
                          >
                            <template v-slot:title>
                              <div
                                class="d-flex align-items-center justify-content-between"
                              >
                                <small>Attachments</small>
                                <span
                                  class="bx bx-x font-size-14 cursor-pointer"
                                  @click="x.viewFile = false"
                                ></span>
                              </div>
                            </template>
                            <table
                              class="table table-bordered"
                              v-if="
                                !x.attachmentLoading &&
                                  x.requisitionFiles.length > 0
                              "
                            >
                              <thead>
                                <tr>
                                  <th>File Description</th>
                                  <th style="width: 30px"></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="y in x.requisitionFiles" :key="y.id">
                                  <td
                                    @click="openDocument(y)"
                                    class="hoverable-link cursor-pointer"
                                  >
                                    <div>
                                      {{ y.description }}
                                    </div>
                                    <small>{{
                                      formatDateWithTime(
                                        new Date(y.dateTimeUploaded)
                                      )
                                    }}</small>
                                  </td>
                                  <td>
                                    <i
                                      v-if="
                                        isAdmin ||
                                          y.applicationUserId ==
                                            token.ApplicationUserId
                                      "
                                      @click="removeFile(y.id, x.id)"
                                      class="cursor-pointer bx bx-trash text-danger"
                                    ></i>
                                    <i
                                      v-else
                                      class="bx bx-trash text-muted"
                                    ></i>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <div
                              class="text-center"
                              v-if="
                                !x.attachmentLoading &&
                                  x.requisitionFiles.length == 0
                              "
                            >
                              No data found
                            </div>
                            <div v-if="x.attachmentLoading" class="text-center">
                              <b-spinner
                                variant="primary"
                                label="Loading..."
                              ></b-spinner>
                            </div>
                          </b-popover>
                        </div>
                        <div class="mt-2">
                          <button
                            :id="`draft-document${x.id}`"
                            type="button"
                            class="btn btn-sm btn-outline-success"
                            @click="x.addDocu = true"
                          >
                            <i class="bx bx-plus"></i>Add Attachments
                          </button>
                          <upload-popover
                            :option="uploadOptions"
                            :sourceId="x.id"
                            @uploaded="uploadedFiles"
                            :showPV="x.addDocu"
                            @closePopover="x.addDocu = false"
                            :dzId="`dropzone-draft${x.id}`"
                            :pvId="`draft-document${x.id}`"
                          ></upload-popover>
                        </div>
                      </div>
                      <div
                        class="border-start border-3 ps-2"
                        style="width: 100%"
                      >
                        <div style="width: 100%">
                          <div class="ms-2">
                            <div
                              class="h-50vh d-flex align-items-center justify-content-center"
                              v-if="x.requisitionItems.length == 0"
                            >
                              <h5 class="text-muted">
                                <i class="fas fa-exclamation-triangle me-2"></i
                                >No Data Found
                              </h5>
                            </div>
                            <div v-else>
                              <div class="mb-2">
                                <table width="100%">
                                  <thead>
                                    <tr class="border-bottom">
                                      <th class="py-2">Item Name</th>
                                      <th style="width: 300px" class="py-2">
                                        Accountable Officer
                                      </th>
                                      <th style="width: 90px" class="py-2">
                                        Qty
                                      </th>
                                      <th class="py-2" style="width: 140px">
                                        Unit Price
                                      </th>
                                      <th class="py-2" style="width: 140px">
                                        Total Price
                                      </th>
                                      <th
                                        class="text-center py-2"
                                        style="width: 60px"
                                      >
                                        Action
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="y in x.requisitionItems"
                                      :key="y.id"
                                      class="border-bottom"
                                    >
                                      <td class="py-2">
                                        {{ y.iarItem.itemName }}
                                      </td>
                                      <td class="py-2">
                                        <div v-if="y.accountableOfficer">
                                          {{y.employeeName ? y.employeeName : formatAccountableOfficer(y.accountableOfficer)}}
                                        </div>
                                      </td>
                                      <td class="py-2 text-info">
                                        {{ y.quantity }}
                                      </td>
                                      <td class="py-2 text-warning">
                                        {{ formatCurrency(y.iarItem.unitCost) }}
                                      </td>
                                      <td class="py-2 text-warning">
                                        {{
                                          formatCurrency(
                                            y.iarItem.unitCost * y.quantity
                                          )
                                        }}
                                      </td>
                                      <td class="text-center py-2">
                                        <i
                                          title="Update Item"
                                          class="mdi mdi-circle-edit-outline font-size-18 text-info cursor-pointer"
                                          @click="updateRequisition(y, x.id)"
                                        ></i>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
          <div class="row">
            <div v-if="rows > 0" class="col">
              Showing {{ (currentPage - 1) * perPage + 1 }} -
              {{
                rows > (currentPage - 1) * perPage + perPage
                  ? (currentPage - 1) * perPage + perPage
                  : rows
              }}
              of {{ rows }}
            </div>
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul
                  class="pagination pagination-rounded mb-0"
                  style="z-index: -1"
                >
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <!-- Posted -->
      <b-tab
        @click="
          getPosted();
          perPage = 10;
          currentPage = 1;
        "
      >
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="mdi mdi-clipboard-edit-outline"></i>
          </span>
          <span class="d-none d-sm-inline-block">Posted</span>
        </template>
        <div v-if="tabIndex == 2" class="card-body ps-0 pe-0">
          <div class="row mb-2">
            <div class="col-md-6">
              <div class="d-flex align-items-center h-100">
                <h5 class="mb-0">List of Posted Requisition</h5>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex float-end">
                <div id="tickets-table_filter" class="dataTables_filter me-1">
                  <label class="d-inline-flex align-items-center">
                    <b-form-input
                      autocomplete="off"
                      v-model="filter"
                      type="search"
                      placeholder="Search Item..."
                      class="form-control"
                    ></b-form-input>
                  </label>
                </div>
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center mb-0">
                    <b-form-select
                      class="form-select"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    >
                    </b-form-select>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <b-card v-if="loading">
            <div class="d-flex align-items-center justify-content-center">
              <div class="preloader-component me-2">
                <div class="status">
                  <div class="spinner-chase w-25px h-25px">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>
              </div>
              <h5 class="mb-0">Loading...</h5>
            </div>
          </b-card>
          <b-card class="text-center" v-else-if="tableData.length == 0">
            <div v-if="filter != ''">
              <i class="fas fa-exclamation-triangle me-2"></i>There are no items
              matching your request
            </div>
            <div v-else>
              <i class="fas fa-exclamation-triangle me-2"></i>No requisitions
              posted
            </div>
          </b-card>
          <div v-else class="text-muted">
            <b-card no-body class="m-0 mb-3" style="min-width: fit-content">
              <b-card-header>
                <div class="d-flex justify-content-between">
                  <h6 class="text-muted m-0" style="min-width: 200px">
                    Requisition
                  </h6>
                  <h6
                    class="text-muted text-center m-0"
                    style="min-width: 60px"
                  >
                    Action
                  </h6>
                </div>
              </b-card-header>
            </b-card>
            <div role="tablist" v-for="(x, index) in paginated" :key="x.id">
              <b-card
                no-body
                class="m-0 mb-3 py-1"
                style="min-width: fit-content"
                :style="`z-index: ${paginated.length - index + 10}`"
              >
                <b-card-header>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div style="min-width: 200px">
                      <h6
                        class="m-0"
                        v-if="
                          x.requisitionItems && x.requisitionItems.length > 0
                        "
                      >
                        PO# {{ x.requisitionItems[0].iarItem.iar.po.poNumber }}
                      </h6>
                      <small class="d-flex align-items-center">
                        <div>
                          {{
                            x.requestedDate
                              ? formatDate(new Date(x.requestedDate))
                              : null
                          }}
                        </div>
                        <div class="ms-1 me-1">|</div>
                        <div>
                          <a
                            href="javascript: void(0);"
                            class="text-success d-flex align-items-center"
                            @click="showDetails(x)"
                          >
                            {{ x.visible ? "Hide" : "Show" }}
                            Items
                            <i
                              class="bx bx-chevron-right rotate font-size-14"
                              :class="{
                                'rotate-90': x.visible
                              }"
                            ></i>
                          </a>
                        </div>
                      </small>
                    </div>
                    <div class="text-center" style="min-width: 60px">
                      <i
                        title="Print RIS"
                        class="bx bx-printer font-size-18 text-purple cursor-pointer me-2"
                        @click="printRIS(x.id)"
                      ></i>
                    </div>
                  </div>
                </b-card-header>
                <b-collapse
                  :visible="x.visible"
                  :accordion="`posted-accordion-${x.id}`"
                  role="tabpanel"
                >
                  <b-card-body
                    v-if="x.visible"
                    class="border border-3 border-bottom-0 border-start-0 border-end-0"
                  >
                    <div class="d-flex">
                      <div class="me-3" style="min-width: 250px">
                        <div>
                          <b class="font-size-14 me-1">Attachments:</b>
                          <a
                            href="javascript:void(0);"
                            @click="getAttachments(x)"
                            :id="`posted-viewFiles-${x.id}`"
                            >[Show attachments]</a
                          >
                          <b-popover
                            :target="`posted-viewFiles-${x.id}`"
                            triggers="click"
                            placement="right"
                            :show.sync="x.viewFile"
                            custom-class="popover-supplier"
                          >
                            <template v-slot:title>
                              <div
                                class="d-flex align-items-center justify-content-between"
                              >
                                <small>Attachments</small>
                                <span
                                  class="bx bx-x font-size-14 cursor-pointer"
                                  @click="x.viewFile = false"
                                ></span>
                              </div>
                            </template>
                            <table
                              class="table table-bordered"
                              v-if="
                                !x.attachmentLoading &&
                                  x.requisitionFiles.length > 0
                              "
                            >
                              <thead>
                                <tr>
                                  <th>File Description</th>
                                  <th style="width: 30px"></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="y in x.requisitionFiles" :key="y.id">
                                  <td
                                    @click="openDocument(y)"
                                    class="hoverable-link cursor-pointer"
                                  >
                                    <div>
                                      {{ y.description }}
                                    </div>
                                    <small>{{
                                      formatDateWithTime(
                                        new Date(y.dateTimeUploaded)
                                      )
                                    }}</small>
                                  </td>
                                  <td>
                                    <i
                                      v-if="
                                        isAdmin ||
                                          y.applicationUserId ==
                                            token.ApplicationUserId
                                      "
                                      @click="removeFile(y.id, x.id)"
                                      class="cursor-pointer bx bx-trash text-danger"
                                    ></i>
                                    <i
                                      v-else
                                      class="bx bx-trash text-muted"
                                    ></i>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <div
                              class="text-center"
                              v-if="
                                !x.attachmentLoading &&
                                  x.requisitionFiles.length == 0
                              "
                            >
                              No data found
                            </div>
                            <div v-if="x.attachmentLoading" class="text-center">
                              <b-spinner
                                variant="primary"
                                label="Loading..."
                              ></b-spinner>
                            </div>
                          </b-popover>
                        </div>
                        <div class="mt-2">
                          <button
                            :id="`posted-document${x.id}`"
                            type="button"
                            class="btn btn-sm btn-outline-success"
                            @click="x.addDocu = true"
                          >
                            <i class="bx bx-plus"></i>Add Attachments
                          </button>
                          <upload-popover
                            :option="uploadOptions"
                            :sourceId="x.id"
                            @uploaded="uploadedFiles"
                            :showPV="x.addDocu"
                            @closePopover="x.addDocu = false"
                            :dzId="`dropzone-posted${x.id}`"
                            :pvId="`posted-document${x.id}`"
                          ></upload-popover>
                        </div>
                      </div>
                      <div
                        class="border-start border-3 ps-2"
                        style="width: 100%"
                      >
                        <div style="width: 100%">
                          <div class="ms-2">
                            <div
                              class="h-50vh d-flex align-items-center justify-content-center"
                              v-if="x.requisitionItems.length == 0"
                            >
                              <h5 class="text-muted">
                                <i class="fas fa-exclamation-triangle me-2"></i
                                >No Data Found
                              </h5>
                            </div>
                            <div v-else>
                              <div class="mb-2">
                                <table width="100%">
                                  <thead>
                                    <tr class="border-bottom">
                                      <th class="py-2">Item Name</th>
                                      <th style="width: 300px" class="py-2">
                                        Accountable Officer
                                      </th>
                                      <th style="width: 90px" class="py-2">
                                        Qty
                                      </th>
                                      <th class="py-2" style="width: 140px">
                                        Unit Price
                                      </th>
                                      <th class="py-2" style="width: 140px">
                                        Total Price
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="y in x.requisitionItems"
                                      :key="y.id"
                                      class="border-bottom"
                                    >
                                      <td class="py-2">
                                        {{ y.iarItem.itemName }}
                                      </td>
                                      <td class="py-2">
                                        <div v-if="y.accountableOfficer">
                                          {{
                                            y.accountableOfficer.firstName
                                              ? `${y.accountableOfficer.firstName
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                  y.accountableOfficer.firstName.slice(
                                                    1
                                                  )}`
                                              : ""
                                          }}
                                          {{
                                            y.accountableOfficer.middleName
                                              ? `${y.accountableOfficer.middleName
                                                  .charAt(0)
                                                  .toUpperCase()}.`
                                              : ""
                                          }}
                                          {{
                                            y.accountableOfficer.lastName
                                              ? `${y.accountableOfficer.lastName
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                  y.accountableOfficer.lastName.slice(
                                                    1
                                                  )}`
                                              : ""
                                          }}
                                        </div>
                                      </td>
                                      <td class="py-2 text-info">
                                        {{ y.quantity }}
                                      </td>
                                      <td class="py-2 text-warning">
                                        {{ formatCurrency(y.iarItem.unitCost) }}
                                      </td>
                                      <td class="py-2 text-warning">
                                        {{
                                          formatCurrency(
                                            y.iarItem.unitCost * y.quantity
                                          )
                                        }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
          <div class="row">
            <div v-if="rows > 0" class="col">
              Showing {{ (currentPage - 1) * perPage + 1 }} -
              {{
                rows > (currentPage - 1) * perPage + perPage
                  ? (currentPage - 1) * perPage + perPage
                  : rows
              }}
              of {{ rows }}
            </div>
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul
                  class="pagination pagination-rounded mb-0"
                  style="z-index: -1"
                >
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <!-- Completed -->
      <b-tab
        @click="
          getCompleted();
          perPage = 10;
          currentPage = 1;
        "
      >
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="mdi mdi-clipboard-edit-outline"></i>
          </span>
          <span class="d-none d-sm-inline-block">Completed</span>
        </template>
        <div v-if="tabIndex == 3" class="card-body ps-0 pe-0">
          <div class="row mb-2">
            <div class="col-md-6">
              <div class="d-flex align-items-center h-100">
                <h5 class="mb-0">List of Completed Requisition</h5>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex float-end">
                <div id="tickets-table_filter" class="dataTables_filter me-1">
                  <label class="d-inline-flex align-items-center">
                    <b-form-input
                      autocomplete="off"
                      v-model="filter"
                      type="search"
                      placeholder="Search Item..."
                      class="form-control"
                    ></b-form-input>
                  </label>
                </div>
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center mb-0">
                    <b-form-select
                      class="form-select"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    >
                    </b-form-select>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <b-card v-if="loading">
            <div class="d-flex align-items-center justify-content-center">
              <div class="preloader-component me-2">
                <div class="status">
                  <div class="spinner-chase w-25px h-25px">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>
              </div>
              <h5 class="mb-0">Loading...</h5>
            </div>
          </b-card>
          <b-card class="text-center" v-else-if="tableData.length == 0">
            <div v-if="filter != ''">
              <i class="fas fa-exclamation-triangle me-2"></i>There are no items
              matching your request
            </div>
            <div v-else>
              <i class="fas fa-exclamation-triangle me-2"></i>No requisitions
              completed
            </div>
          </b-card>
          <div v-else class="text-muted">
            <b-card no-body class="m-0 mb-3" style="min-width: fit-content">
              <b-card-header>
                <div class="d-flex justify-content-between">
                  <h6 class="text-muted m-0" style="min-width: 200px">
                    Requisition
                  </h6>
                  <h6
                    class="text-muted text-center m-0"
                    style="min-width: 60px"
                  >
                    Action
                  </h6>
                </div>
              </b-card-header>
            </b-card>
            <div role="tablist" v-for="(x, index) in paginated" :key="x.id">
              <b-card
                no-body
                class="m-0 mb-3 py-1"
                style="min-width: fit-content"
                :style="`z-index: ${paginated.length - index + 10}`"
              >
                <b-card-header>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div style="min-width: 200px">
                      <h6
                        class="m-0"
                        v-if="
                          x.requisitionItems && x.requisitionItems.length > 0
                        "
                      >
                        PO# {{ x.requisitionItems[0].iarItem.iar.po.poNumber }}
                      </h6>
                      <small class="d-flex align-items-center">
                        <div>
                          {{
                            x.requestedDate
                              ? formatDate(new Date(x.requestedDate))
                              : null
                          }}
                        </div>
                        <div class="ms-1 me-1">|</div>
                        <div>
                          <a
                            href="javascript: void(0);"
                            class="text-success d-flex align-items-center"
                            @click="showDetails(x)"
                          >
                            {{ x.visible ? "Hide" : "Show" }}
                            Items
                            <i
                              class="bx bx-chevron-right rotate font-size-14"
                              :class="{
                                'rotate-90': x.visible
                              }"
                            ></i>
                          </a>
                        </div>
                      </small>
                    </div>
                    <div class="text-center" style="min-width: 60px">
                      <i
                        title="Print RIS"
                        class="bx bx-printer font-size-18 text-purple cursor-pointer me-2"
                        @click="printRIS(x.id)"
                      ></i>
                    </div>
                  </div>
                </b-card-header>
                <b-collapse
                  :visible="x.visible"
                  :accordion="`completed-accordion-${x.id}`"
                  role="tabpanel"
                >
                  <b-card-body
                    v-if="x.visible"
                    class="border border-3 border-bottom-0 border-start-0 border-end-0"
                  >
                    <div class="d-flex">
                      <div class="me-3" style="min-width: 250px">
                        <div>
                          <b class="font-size-14 me-1">Attachments:</b>
                          <a
                            href="javascript:void(0);"
                            @click="getAttachments(x)"
                            :id="`completed-viewFiles-${x.id}`"
                            >[Show attachments]</a
                          >
                          <b-popover
                            :target="`completed-viewFiles-${x.id}`"
                            triggers="click"
                            placement="right"
                            :show.sync="x.viewFile"
                            custom-class="popover-supplier"
                          >
                            <template v-slot:title>
                              <div
                                class="d-flex align-items-center justify-content-between"
                              >
                                <small>Attachments</small>
                                <span
                                  class="bx bx-x font-size-14 cursor-pointer"
                                  @click="x.viewFile = false"
                                ></span>
                              </div>
                            </template>
                            <table
                              class="table table-bordered"
                              v-if="
                                !x.attachmentLoading &&
                                  x.requisitionFiles.length > 0
                              "
                            >
                              <thead>
                                <tr>
                                  <th>File Description</th>
                                  <th style="width: 30px"></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="y in x.requisitionFiles" :key="y.id">
                                  <td
                                    @click="openDocument(y)"
                                    class="hoverable-link cursor-pointer"
                                  >
                                    <div>
                                      {{ y.description }}
                                    </div>
                                    <small>{{
                                      formatDateWithTime(
                                        new Date(y.dateTimeUploaded)
                                      )
                                    }}</small>
                                  </td>
                                  <td>
                                    <i
                                      v-if="
                                        isAdmin ||
                                          y.applicationUserId ==
                                            token.ApplicationUserId
                                      "
                                      @click="removeFile(y.id, x.id)"
                                      class="cursor-pointer bx bx-trash text-danger"
                                    ></i>
                                    <i
                                      v-else
                                      class="bx bx-trash text-muted"
                                    ></i>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <div
                              class="text-center"
                              v-if="
                                !x.attachmentLoading &&
                                  x.requisitionFiles.length == 0
                              "
                            >
                              No data found
                            </div>
                            <div v-if="x.attachmentLoading" class="text-center">
                              <b-spinner
                                variant="primary"
                                label="Loading..."
                              ></b-spinner>
                            </div>
                          </b-popover>
                        </div>
                        <div class="mt-2">
                          <button
                            :id="`completed-document${x.id}`"
                            type="button"
                            class="btn btn-sm btn-outline-success"
                            @click="x.addDocu = true"
                          >
                            <i class="bx bx-plus"></i>Add Attachments
                          </button>
                          <upload-popover
                            :option="uploadOptions"
                            :sourceId="x.id"
                            @uploaded="uploadedFiles"
                            :showPV="x.addDocu"
                            @closePopover="x.addDocu = false"
                            :dzId="`dropzone-completed${x.id}`"
                            :pvId="`completed-document${x.id}`"
                          ></upload-popover>
                        </div>
                      </div>
                      <div
                        class="border-start border-3 ps-2"
                        style="width: 100%"
                      >
                        <div style="width: 100%">
                          <div class="ms-2">
                            <div
                              class="h-50vh d-flex align-items-center justify-content-center"
                              v-if="x.requisitionItems.length == 0"
                            >
                              <h5 class="text-muted">
                                <i class="fas fa-exclamation-triangle me-2"></i
                                >No Data Found
                              </h5>
                            </div>
                            <div v-else>
                              <div class="mb-2">
                                <table width="100%">
                                  <thead>
                                    <tr class="border-bottom">
                                      <th class="py-2">Item Name</th>
                                      <th style="width: 300px" class="py-2">
                                        Accountable Officer
                                      </th>
                                      <th style="width: 90px" class="py-2">
                                        Qty
                                      </th>
                                      <th class="py-2" style="width: 140px">
                                        Unit Price
                                      </th>
                                      <th class="py-2" style="width: 140px">
                                        Total Price
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="y in x.requisitionItems"
                                      :key="y.id"
                                      class="border-bottom"
                                    >
                                      <td class="py-2">
                                        {{ y.iarItem.itemName }}
                                      </td>
                                      <td class="py-2">
                                        <div v-if="y.accountableOfficer">
                                          {{
                                            y.accountableOfficer.firstName
                                              ? `${y.accountableOfficer.firstName
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                  y.accountableOfficer.firstName.slice(
                                                    1
                                                  )}`
                                              : ""
                                          }}
                                          {{
                                            y.accountableOfficer.middleName
                                              ? `${y.accountableOfficer.middleName
                                                  .charAt(0)
                                                  .toUpperCase()}.`
                                              : ""
                                          }}
                                          {{
                                            y.accountableOfficer.lastName
                                              ? `${y.accountableOfficer.lastName
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                  y.accountableOfficer.lastName.slice(
                                                    1
                                                  )}`
                                              : ""
                                          }}
                                        </div>
                                      </td>
                                      <td class="py-2 text-info">
                                        {{ y.quantity }}
                                      </td>
                                      <td class="py-2 text-warning">
                                        {{ formatCurrency(y.iarItem.unitCost) }}
                                      </td>
                                      <td class="py-2 text-warning">
                                        {{
                                          formatCurrency(
                                            y.iarItem.unitCost * y.quantity
                                          )
                                        }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
          <div class="row">
            <div v-if="rows > 0" class="col">
              Showing {{ (currentPage - 1) * perPage + 1 }} -
              {{
                rows > (currentPage - 1) * perPage + perPage
                  ? (currentPage - 1) * perPage + perPage
                  : rows
              }}
              of {{ rows }}
            </div>
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul
                  class="pagination pagination-rounded mb-0"
                  style="z-index: -1"
                >
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>
    <print-options ref="printOpt"></print-options>
  </Layout>
</template>

<style>
.VueCarousel-slide-adjustableHeight {
  display: block !important;
}
.VueCarousel-inner {
  align-items: flex-start !important;
}
</style>
